var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddUser = function SvgAddUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1_1",
    "data-name": "Component 1 \\u2013 1",
    width: 19.171,
    height: 16.904,
    viewBox: "0 0 19.171 16.904",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4186",
    "data-name": "Path 4186",
    d: "M1112.5,59.167a3.333,3.333,0,1,1,3.33-3.333A3.331,3.331,0,0,1,1112.5,59.167Zm8.33,0a.831.831,0,0,1-.83-.833V56.667h-1.67a.833.833,0,0,1,0-1.667H1120V53.333a.831.831,0,0,1,.83-.833.839.839,0,0,1,.84.833V55h1.66a.833.833,0,1,1,0,1.667h-1.66v1.667A.839.839,0,0,1,1120.83,59.167Z",
    transform: "translate(-1104.999 -52.5)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4187",
    "data-name": "Path 4187",
    d: "M1105,66.833c.32-3.977,3.55-6,7.49-6,3.99,0,7.26,1.911,7.51,6a.573.573,0,0,1-.63.667h-13.76A.922.922,0,0,1,1105,66.833Z",
    transform: "translate(-1104.999 -50.596)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-user.15b1444c.svg";
export { ForwardRef as ReactComponent };